import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

const LOGO_URL = "/images/favicon.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/products", label: "Collections" },
    { path: "/about", label: "Heritage" },
    { path: "/contact", label: "Enquire" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="glass-light fixed top-0 left-0 right-0 z-50 shadow-soft" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          <Link to="/" className="flex items-center" data-testid="nav-logo">
            <img src={LOGO_URL} alt="Shree Ganesh Ornaments" className="h-16 w-auto" />
          </Link>

          <div className="hidden md:flex items-center space-x-12">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.label.toLowerCase()}`}
                className={`font-display text-xs tracking-[0.3em] uppercase transition-all duration-500 ${isActive(link.path) ? "text-royal-gold" : "text-charcoal/70 hover:text-royal-gold"
                  }`}
              >
                {link.label}
              </Link>
            ))}
            <a href="tel:+919104054250" data-testid="nav-call-btn" className="btn-luxury flex items-center space-x-2 text-xs py-3 px-6">
              <Phone size={14} />
              <span>Call</span>
            </a>
          </div>

          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden p-2 text-charcoal hover:text-royal-gold" data-testid="mobile-menu-toggle">
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-gold-muted/10">
          <div className="px-6 py-8 space-y-6">
            {navLinks.map((link) => (
              <Link key={link.path} to={link.path} onClick={() => setIsOpen(false)} data-testid={`mobile-nav-${link.label.toLowerCase()}`}
                className={`block font-display text-sm tracking-[0.2em] uppercase py-2 ${isActive(link.path) ? "text-royal-gold" : "text-charcoal/70 hover:text-royal-gold"}`}>
                {link.label}
              </Link>
            ))}
            <a href="tel:+919104054250" className="btn-luxury flex items-center justify-center space-x-2 text-xs py-3 mt-4">
              <Phone size={14} /><span>Call Now</span>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
